module.exports = __webpack_public_path__ + "img/Group 7.35b3f829.svg";